const _employeeName = Symbol();
const _contactNo = Symbol();
const _address = Symbol();
const _imagePath = Symbol();
const _documentPath = Symbol();
const _employeeId = Symbol();
const _payRate = Symbol();
const _joinDate = Symbol();
const _errs = Symbol();


class Employee {
    constructor({ employeeName, contactNo, address, imagePath, documentPath, employeeId, payRate, joinDate }) {

        this[_errs] = {};

        Object.defineProperties(this, {
            employeeName: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 45) {
                        this[_employeeName] = value.toLowerCase();
                        delete this[_errs].employeeName;
                    } else {
                        this[_errs].employeeName = "Employee name  must be between 2 to 45 characters";
                    }
                },
                get: function () {
                    return this[_employeeName];
                }
            },

            contactNo: {
                enumerable: true,
                configurable: true,
                set: function (value) {

                    if (typeof value === "string" && value.length >= 10 && value.length <= 20) {

                        this[_contactNo] = value;
                        delete this[_errs].contactNo;
                    } else {
                        this[_errs].contactNo = "Contact number must be between 10 to 20 characters";
                    }
                },
                get: function () {
                    return this[_contactNo];
                }
            },

            address: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 200) {
                        this[_address] = value.toLowerCase();
                        delete this[_errs].address;
                    } else {
                        this[_errs].address = "address number must be between 2 to 200 characters";
                    }
                },
                get: function () {
                    return this[_address];
                }
            },

            imagePath: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    this[_imagePath] = value || null;
                },
                get: function () {
                    return this[_imagePath];
                }
            },

            documentPath: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    this[_documentPath] = value || null;
                },
                get: function () {
                    return this[_documentPath];
                }
            },

            employeeId: {
                enumerable: true,
                configurable: true,
                set: function (value = null) {
                    this[_employeeId] = value;
                },
                get: function () {
                    return this[_employeeId];
                }
            },
            payRate: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    if (!isNaN(value) && parseFloat(value) && value > 0) {
                        this[_payRate] = parseFloat(value);
                        delete this[_errs].payRate;
                    } else {
                        this[_errs].payRate = "please enter a valid payrate";
                    }
                },
                get: function () {
                    return this[_payRate];
                }
            },
            joinDate: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    const pattern = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/;
                    if (pattern.test(value) && Date.parse(value)) {
                        this[_joinDate] = value;
                        delete this[_errs].joinDate;
                    } else {
                        this[_errs].joinDate = "please enter a valid join date YYYY-MM-DD format";
                    }
                },
                get: function () {
                    return this[_joinDate];
                }
            }

        });

        this.employeeName = employeeName;
        this.contactNo = contactNo;
        this.address = address;
        this.imagePath = imagePath;
        this.documentPath = documentPath;
        this.employeeId = employeeId;
        this.payRate = payRate;
        this.joinDate = joinDate;

    }


    hasError() {
        return Object.keys(this[_errs]).length > 0;
    }

    getErrors() {
        return this[_errs];
    }

}

module.exports = Employee;


// WEBPACK FOOTER //
// ./src/models/employee.js